/* BDF cart architecture: shipping progress is now managed centrally by assets/bdf-cart.js. */

/* BDF — canonical size guide modal controller. */
(function () {
  'use strict';

  var activeModal = null;
  var activeTrigger = null;
  var lastFocus = null;

  function getLang() {
    return (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  }

  function getCopy() {
    var copies = {
      fr: { detail: 'Voir le guide complet', detailAria: 'Ouvrir la page complète du guide des tailles' },
      en: { detail: 'View full size guide', detailAria: 'Open the full size guide page' },
      es: { detail: 'Ver la guía de tallas completa', detailAria: 'Abrir la página completa de la guía de tallas' }
    };
    return copies[getLang()] || copies.fr;
  }

  function getFocusable(modal) {
    if (!modal) return [];
    return Array.from(modal.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
  }

  function addDetailedPageLink(modal) {
    if (!modal) return;
    var url = modal.getAttribute('data-bdf-detail-url');
    if (!url) return;

    var guide = modal.querySelector('.bdf-size-guide');
    var footer = guide && guide.querySelector('.bdf-size-guide__footer');
    if (!footer || footer.querySelector('.bdf-size-guide__detail-link')) return;

    var copy = getCopy();
    var link = document.createElement('a');
    link.className = 'bdf-size-guide__link bdf-size-guide__detail-link';
    link.href = url;
    link.textContent = copy.detail;
    link.setAttribute('aria-label', copy.detailAria);
    footer.appendChild(link);
  }

  function openModal(modal, trigger) {
    if (!modal || !trigger) return;

    lastFocus = document.activeElement && document.activeElement !== document.body
      ? document.activeElement
      : trigger;
    activeModal = modal;
    activeTrigger = trigger;

    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('bdf-size-guide-lock');

    window.requestAnimationFrame(function () {
      modal.classList.add('bdf-size-modal-open');
    });

    var focusable = getFocusable(modal);
    if (focusable.length) {
      window.setTimeout(function () { focusable[0].focus(); }, 40);
    }
  }

  function closeModal() {
    if (!activeModal) return;

    var modal = activeModal;
    var trigger = activeTrigger;
    activeModal = null;
    activeTrigger = null;

    modal.classList.remove('bdf-size-modal-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bdf-size-guide-lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    window.setTimeout(function () {
      if (!modal.classList.contains('bdf-size-modal-open')) modal.style.display = 'none';
    }, 230);

    var focusTarget = lastFocus && typeof lastFocus.focus === 'function' ? lastFocus : trigger;
    lastFocus = null;
    if (focusTarget) {
      window.setTimeout(function () { focusTarget.focus(); }, 20);
    }
  }

  function trapFocus(event) {
    if (!activeModal || event.key !== 'Tab') return;

    var focusable = getFocusable(activeModal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var current = document.activeElement;

    if (!activeModal.contains(current)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
      return;
    }

    if (event.shiftKey && current === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && current === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function initSizePopup() {
    var modal = document.getElementById('scModal');
    var trigger = document.getElementById('scBtn');
    if (!modal || !trigger || modal.getAttribute('data-bdf-size-bound') === 'true') return;

    modal.setAttribute('data-bdf-size-bound', 'true');
    modal.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    var closeButton = modal.querySelector('.sc-close');
    addDetailedPageLink(modal);

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      openModal(modal, trigger);
    });

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });
    }

    modal.addEventListener('click', function (event) {
      event.stopPropagation();
      if (event.target === modal) closeModal();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!activeModal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    trapFocus(event);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizePopup, { once: true });
  } else {
    initSizePopup();
  }

  document.addEventListener('shopify:section:load', initSizePopup);
}());
